import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const windstormMitigation: TaskDefinition = {
  taskName: onboardingTasks.ConfirmWindstormMitigationStatus,
  config: {
    staffDisplayName: 'Proof of advanced windstorm mitigation',
    appcuesModalId: '416d477c-d154-4e60-bd07-ead1f62a4582',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 15,
    enabled: true,
    eventName: 'Confirmed Windstorm Mitigation Status',
    account: {
      toastMessage: 'Your proof of advanced windstorm mitigation documents have been submitted for review.',
      content: ({ affectedPolicies, daysAllowed }) => ({
        title: 'Proof of Advanced Windstorm Mitigation',
        incompleteSubtitle: 'Provide proof of your windstorm mitigation features to keep your discount.',
        completedSubtitle: `You have successfully submitted for review the windstorm mitigation documents for ${affectedPolicies}.`,
        actionLabel: 'Upload proof',
        modalTitle: 'Upload your proof of advanced windstorm mitigation',
        contentSections: [
          {
            title: 'What documents are accepted?',
            body: "Windstorm mitigation inspection report or other official documentation showing your home's windstorm mitigation features"
          },
          {
            title: 'When do I need to submit these documents?',
            body: `You have ${daysAllowed} days from your policy effective date to turn in verification listed above before the discount is removed.`
          }
        ]
      })
    }
  }
};
